import "init/jiffy";
import "common/base";

/* ca */
import "components/jiffy/masthead/masthead";
import initMastheadRedesign2025 from "components/jiffy/masthead-redesign2025/masthead-redesign2025";
import "components/jiffy/price-line-through/price-line-through";
import "components/jiffy/usa-redirect-modal/usa-redirect-modal";
import "components/jiffy/app-store-badge/app-store-badge";
import initPDPTransfer from "components/jiffy/product-details-transfer/product-details-transfer";

/* application */
import "components/jiffy/product-card-badge/product-card-badge";
import "components/jiffy/promo-banner-list/promo-banner-list";
import "components/jiffy/promo-banner/promo-banner";
import "components/jiffy/button-box/button-box";
import "components/jiffy/text-box/text-box";
import "components/jiffy/check-box/check-box";
import "components/jiffy/input-box/input-box";
import "components/jiffy/radio-box/radio-box";
import "components/jiffy/flash-messages/flash-messages";
import "components/jiffy/fast-delivery-information/fast-delivery-information";
import "components/spinner/component";
import "components/kit/breadcrumbs/component";
import initSoftnessScore from "components/compositions/softness_score/component";
import initSatisfactionGuaranteed from "components/compositions/satisfaction_guaranteed/component";
import "components/jiffy/jiffy-pagination/jiffy-pagination";
import initAccessibility from "common/jiffy/accessibility";
import initModalWrapper from "components/jiffy/modal-wrapper/modal-wrapper";
import initSocialLinks from "components/jiffy/social-icons/social-icons";
import init from "components/jiffy/product-details/product-details";
import initSeoModifications from "common/jiffy/seo-modifications";

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".js-social-link")) initSocialLinks();
  if (document.querySelector(".js-product-details-transfer")) initPDPTransfer();

  initAccessibility();
  initModalWrapper();
  initSoftnessScore();
  initSeoModifications();
  initSatisfactionGuaranteed();
  initMastheadRedesign2025();
  init();
});
